import architect from './../images/cloudArchitect.png';

const WellArchitected = () => {
    return (
      <div>
      <p className="standard-paragraph">
      <div class="container">
        <div class="image-container">
          <img src={architect} alt="Architect" width={300}/>
        </div>
        <div class="text-container">
          <h2>Well Architected Project</h2>
          <p class="text-text">
            Forge robust and scalable AWS well-architected projects with our expert guidance. We prioritize best practices 
            in areas like operational excellence, security, and cost optimization, ensuring your cloud infrastructure aligns 
            with industry standards. Explore our software development services, encompassing end-to-end support in crafting 
            and maintaining AWS well-architected solutions that stand the test of scalability, security, and efficiency.
          </p>
        </div>
      </div>
      
      <ul class="custom-list">
      <li><strong>Operational Excellence:</strong> AWS CloudWatch, AWS CloudFormation, AWS Systems Manager</li>
      <li><strong>Security:</strong> AWS IAM, AWS KMS, AWS Config, AWS Security Hub</li>
      <li><strong>Reliability:</strong> AWS Auto Scaling, Amazon Route 53, AWS Global Accelerator</li>
      <li><strong>Performance Efficiency:</strong> Amazon CloudFront, AWS Elastic Load Balancing, Amazon RDS Performance Insights</li>
      <li><strong>Cost Optimization:</strong> AWS Cost Explorer, AWS Trusted Advisor, AWS Budgets</li>
      <li><strong>Well-Architected Tool:</strong> AWS Well-Architected Tool</li>
      <li><strong>Infrastructure as Code (IaC):</strong> AWS Cloud Development Kit (CDK)</li>
      <li><strong>Automation and Orchestration:</strong> AWS Step Functions, AWS Lambda</li>
      <li><strong>Security and Compliance Tools:</strong> AWS IAM, AWS Organizations, AWS Config</li>
      <li><strong>Performance Analysis and Optimization:</strong> Amazon CloudWatch, AWS X-Ray, AWS Trusted Advisor</li>
      <li><strong>Resource Scaling and Elasticity:</strong> Amazon EC2 Auto Scaling, AWS Application Auto Scaling</li>
      <li><strong>Data Backup and Recovery:</strong> Amazon S3 Versioning, AWS Backup</li>
      <li><strong>Cloud Cost Management:</strong> AWS Cost Explorer, AWS Budgets</li>
      <li><strong>Network Resilience and Availability:</strong> Amazon VPC, AWS Global Accelerator</li>
      </ul>
      </p>
      </div>)
  };
  
  export default WellArchitected;